import React from 'react'

// Hooks
import { useGlobal } from '../../../../../hooks'

import AdministrationInfo from '../..'

// Queries
import { READ_ESSAY_UNITS, DELETE_ESSAY_UNITS } from './queries'

const AdministrationInfoSamplingEssayUnits = ({ ...rest }) => {
  const [{ me }] = useGlobal()

  const no = ![1, 2].includes(me.id_role)

  return (
    <AdministrationInfo
      queries={{ read: READ_ESSAY_UNITS, delete: DELETE_ESSAY_UNITS }}
      title="Unidad de medida"
      {...rest}
      noDuplicate={no}
      noUpdate={no}
      noDelete={no}
    />
  )
}

export default AdministrationInfoSamplingEssayUnits
